import { POSTPONE_ACTION_WITH_LOADER_TIMEOUT } from '../../constants/timeouts';
import captureException from '../../utils/captureException';
import delay from '../../utils/delay';
import { SET_IS_LOADING } from './reducer';
export const postponeWithAppLoader = ({
  dispatch
}, cb) => {
  dispatch({
    type: SET_IS_LOADING,
    payload: true
  });
  delay(POSTPONE_ACTION_WITH_LOADER_TIMEOUT).then(() => {
    if (cb && typeof cb === 'function') cb();
    return;
  }).catch(captureException).finally(() => {
    dispatch({
      type: SET_IS_LOADING,
      payload: false
    });
  });
};